import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">精选推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队为你精选的本周必看影视内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group cursor-pointer bg-background-100 rounded-lg overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-500/85 text-white whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-background-50/80 backdrop-blur-sm">
                  <i className="ri-star-fill text-xs text-secondary-400"></i>
                  <span className="text-xs font-semibold text-foreground-700">{card.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5 group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}